export const moveElemInArray = (arr, old_index, new_index) => {
    while (old_index < 0) {
        old_index += arr.length;
    }
    while (new_index < 0) {
        new_index += arr.length;
    }
    if (new_index >= arr.length) {
        let k = new_index - arr.length + 1;
        while (k--) {
            arr.push(undefined);
        }
    }
    arr.splice(new_index, 0, arr.splice(old_index, 1)[0]);
    return arr;
};
export const mapOrder = (array, order, key) => {
    array.sort(function (a, b) {
        const A = a[key], B = b[key];
        if (order.indexOf(A) > order.indexOf(B) || order.indexOf(A) === -1 || order.indexOf(B) === -1) {
            return 1;
        }
        else {
            return -1;
        }
    });
    return array;
};
// Base64 Decode
export const b64D = (encodedString) => {
    return atob(encodedString);
};
export const scaleDeviceRatio = (height, width, maximumMultiple) => {
    const ratio = window.devicePixelRatio || 1;
    let logicalWidth = width;
    let logicalHeight = height;
    let actualWidth = logicalWidth * ratio;
    let actualHeight = logicalHeight * ratio;
    // Check if the pixel area exceeds the limit
    if (actualWidth * actualHeight > maximumMultiple) {
        // Scale down the canvas to fit within limits while preserving aspect ratio
        const scaleFactor = Math.sqrt(maximumMultiple / (actualWidth * actualHeight));
        logicalWidth = logicalWidth * scaleFactor;
        logicalHeight = logicalHeight * scaleFactor;
        actualWidth = logicalWidth * ratio;
        actualHeight = logicalHeight * ratio;
    }
    return {
        height: logicalHeight,
        width: logicalWidth,
    };
};
export const convertToHandle = (str) => {
    return str.toLowerCase().split(' ').join('-');
};
export const removeSpaces = (str) => {
    return str.toLowerCase().split(' ').join('');
};
export const moveIndex = (array, index, direction) => {
    if (direction === 'down' && index > 0) {
        // Swap with the previous element
        [array[index], array[index - 1]] = [array[index - 1], array[index]];
    }
    else if (direction === 'up' && index < array.length - 1) {
        // Swap with the next element
        [array[index], array[index + 1]] = [array[index + 1], array[index]];
    }
    return array;
};
